<template>
    <Card class="resetPWCard md:p-5 w-full md:w-8 lg:w-8">
        <template #title>
            <div class="text-center Paragraph-Medium">
                Enter Code
            </div>
        </template>
        <template #subtitle>
            <div class="text-center Caption">
                We sent the code to {{props.userEmail}}, please enter it here.
            </div>
        </template>
        <template #content>
            <div class="flex flex-column align-items-center gap-3 pt-4">
                <label for="username" class="Label align-self-start">Code</label>
                <IconField class="w-full">
                    <InputIcon class="pi pi-user" />
                    <InputText v-model="code" placeholder="Enter code here" size="small" variant="filled"
                        class="w-full" />
                </IconField>
            </div>
            <div class="flex-column flex align-items-center pt-6">
                <Button label="Submit" class="teal-700-button" :disabled="code.length < 1" @click="verifyResetCode" />
                <label for="username" class="Label pt-3 ">Didn't get the email? Click to <span
                        class="Label-teal cursor-pointer" @click="generateResetCode">Resend</span></label>
                <label for="username" class="Label pt-3 ">Remember password? <span class="Label-teal cursor-pointer"
                        @click="Login">Login</span></label>
            </div>
        </template>
    </Card>
</template>
<script setup>
import Card from 'primevue/card';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';

import { useRouter } from "vue-router";
import { ref, defineProps, defineEmits } from 'vue';
import * as authApi from "@/api/auth";
import { notifySuccess, notifyError } from "@/utils/notification";

const props = defineProps({
  userEmail: {
    type: String,
    required: true,
  },
});

const router = useRouter();
const code = ref("");

const emit = defineEmits(["to-step-three"]);

const generateResetCode = async () => {
    try {
        await authApi.generatePasswordResetToken({ email: props.userEmail });
        notifySuccess("Success", "We have resent the code to your email.");
    } catch (err) {
        notifyError("Error", "An error occurred. Please try again and make sure the email is correct.");
    }
};

const verifyResetCode = async () => {
    try {
        await authApi.verifyResetToken({ email: props.userEmail, code: code.value });
        notifySuccess("Success", "The code has been verified.");
        emit("to-step-three", 3);
    } catch (err) {
        notifyError("Error", "An error occurred. Please try again and make sure the code is correct.");
    }
};
const Login = async () => {
    router.push('/login');
}
</script>
<style scoped>
.resetPWCard {
  border: none;
  box-shadow: none;
}
</style>
